<template>
  <layout-default-appbar filterabl>
      Ordem Produção
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_PRODUCAO } from '@/constants/ROUTES';

export default {
  name: 'ViewLoteAppBar',

  components: {
    LayoutDefaultAppbar,
  },

    data() {
    return {
      rota: ROUTE_PRODUCAO,
    }
  }

};
</script>
